const config = {
    cookie_token_key: 'wikismarts_session_id'
};

export default config;
